// 设备信息类型
export interface DeviceInfo {
  userAgent: string;
  platform: string;
  language: string;
  timezone: string;
  screenResolution: string;
  colorDepth: number;
  browser: {
    name: string;
    version: string;
    engine: string;
  };
  deviceType: "mobile" | "tablet" | "desktop";
  connection: {
    effectiveType?: string;
    downlink?: number;
    rtt?: number;
  };
  location?: {
    latitude?: number;
    longitude?: number;
    accuracy?: number;
  };
  session: {
    sessionId: string;
    timestamp: number;
  };
}

export enum ConversationStatusEnum {
  CLOSED = "closed",
  ACTIVE = "active",
  HANDOFF = "handoff",
  PENDING = "pending",
}

export enum HandoffActionEnum {
  CONFIRMED = "confirmed",
  CANCELLED = "cancelled",
  NONE = "none",
}

export interface Conversation {
  conversation_id: number;
  conversation_status: ConversationStatusEnum;
}

export interface MessageTextContent {
  text: string;
}

export interface MessageFunctionContent {
  type: string;
  data: any;
}

export interface MessageContent {
  type: "text" | "function";
  content: MessageTextContent | MessageFunctionContent;
}

export enum MessageStatusEnum {
  PROCESSING = "processing",
  COMPLETED = "completed",
}

// 消息类型
export interface MessageData {
  message_id: string;
  message_status: MessageStatusEnum;
  type: "user" | "response";
  role: "user" | "assistant" | "system";
  content: MessageContent[];
  files?: File[];
  created_at: string;
  conversation_id: number;
  conversation_status: ConversationStatusEnum;
  is_like: boolean | null;
}

export enum FileStatus {
  UPLOADING = "uploading",
  SUCCESSED = "successed",
  FAILED = "failed",
}

export interface File {
  id: string;
  localUrl?: string; // 本地预览地址
  url: string;
  name: string;
  size: number;
  type: string;
  status: FileStatus;
}

interface FAQItemData {
  id: string;
  name: string;
}

// FAQ 推荐项
export interface FAQRecommendItemData extends FAQItemData {
  type: "url" | "answer";
  value: string;
}

// FAQ 列表项
export interface FAQSearchItemData extends FAQItemData {}

// FAQ 详情项
export interface FAQDetailData extends FAQItemData {
  body: string;
}

// Proactive Greeting
export interface ProactiveMessage {
  text: string;
}

// 文件上传相关类型
export interface PresignUploadRequest {
  file_name: string;
  // file_type: string;
  // file_size: number;
}

export interface PresignUploadResponse {
  code: number;
  data: {
    // presigned_url: string;
    upload_url: string;
    // file_id: string;
    file_url: string;
  };
  msg: string;
}

// AB 测试变体
export type ABVariant = "gladly" | "ai";

export type ExternalEntryPath = "contact_us_page" | "chat_online_menu";

// 入口路径
export type EntryPath =
  | "proactive"
  | "faq"
  | "entry_button"
  | ExternalEntryPath;

// 当前视图
export type CurrentView = "faq" | "faq-detail" | "chatbox";

// 用户登录状态
export type UserLoginStatus = "logged_in" | "logged_out" | "checking";

export enum Market {
  SG = "SG",
  US = "US",
  CA = "CA",
  UK = "UK",
  AU = "AU",
}

// 聊天状态
export interface ChatState {
  expanded: boolean;
  entryPath: EntryPath;
  messages: MessageData[];
  timestamp: number;
}

// API 响应类型
export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

// 聊天历史响应
export interface ChatHistoryResponse {
  list: MessageData[];
  page: number;
  page_size: number;
  total: number;
  is_optional_login_pending: boolean;
}

// 文件上传响应
export interface FileUploadResponse {
  url: string;
  filename: string;
  size: number;
}
